<template>
  <div class="enterprise-weChat">
    <h2 class="is-print-hide title-area">
      <span class="main-title">企业微信</span>
    </h2>
    <div class="box-wrap" v-if="!data.corpId && this.authorizeLinkUrl">
      <div class="box1">
        <div class="banner-inner">
          <div class="content">
            <i class="logo-name iconfont icon-yaodianyiLogo"></i>
            <div class="txt2">
              药点益，是智云健康旗下专为传统零售药店提供的基于企业微信的客户营销管理系统。可基于智云问诊小程序自动沉淀客户，对客户进行药事服务、营销转化，更可在药点益学习药学知识、营销技巧等，赋能药店经营。
            </div>
            <div class="btns">
              <a class="btn btn1" target="_blank" :href="authorizeLinkUrl">
                <span class="highLight">立即授权</span>
                <span class="tip">已有企业微信</span>
              </a>
              <a
                class="btn btn2"
                target="_blank"
                href="https://work.weixin.qq.com/wework_admin/register_wx?from=service_register"
              >
                <span class="highLight">一键注册</span>
                <span class="tip">没有企业微信</span>
              </a>
            </div>
          </div>
          <img
            class="wechat-bg-right"
            src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/enterprise-wechat-bg-right.png"
            alt=""
          />
        </div>
      </div>
      <div class="box2">
        <div class="odds">核心优势</div>
        <div class="intros">
          <div class="intro-item">
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/auto-precipitation.png" />
            <p class="title">问诊客户 自动沉淀</p>
            <p class="text">问诊开方用户自然沉淀至药店的企微，以一对一、或门店群的形式存在，轻松解决会员拉新问题</p>
          </div>
          <div class="intro-item">
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/service-efficiency.png" />
            <p class="title">提高客户 服务效率</p>
            <p class="text">
              平台代替店员自动给客户发送用药指导和提醒，推送回访任务给店员（待复购、新客维系、生日提醒等），提供模板话术，提高店员服务客户的效率
            </p>
          </div>
          <div class="intro-item">
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/member-marketing.png" />
            <p class="title">会员精准营销</p>
            <p class="text">
              提供多维度的客户标签，根据处方记录，自动为客户打上疾病标签，可根据标签对其展开精准活动营销（包括活动海报、社区拼团、线下代金券、微商城打通等）
            </p>
          </div>
          <div class="intro-item">
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/learning-growth.png" />
            <p class="title">学习成长</p>
            <p class="text">
              提供专业丰富的药品知识和在线课程，输出专业的培训内容，帮助药店学习药品知识，帮助药店提升经营能力
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="box-wrap" v-if="data.corpId">
      <div class="box3">
        <div class="item">
          <div class="label">企业ID</div>
          <div class="txt">{{ data.corpId }}</div>
        </div>
        <div class="item">
          <div class="label">外部联系人秘钥</div>
          <el-input
            v-model="data.contactSecret"
            :maxlength="43"
            placeholder="请输入"
            style="width: 416px"
            clearable
          ></el-input>
          <div class="get-secret" @click="showContactSecretKey = true">如何获取秘钥</div>
        </div>
        <div class="item">
          <div class="label">通讯录秘钥</div>
          <el-input
            v-model="data.relationSecret"
            :maxlength="43"
            placeholder="请输入"
            style="width: 416px"
            clearable
          ></el-input>
          <div class="get-secret" @click="showRelationSecretKey = true">如何获取秘钥</div>
        </div>

        <el-button :disabled="!isLinehight" type="primary" class="submit" @click="onSubmit">保存</el-button>
      </div>
    </div>
    <div class="show-secret">
      <el-drawer :visible.sync="showContactSecretKey" direction="rtl" size="664">
        <div class="boder-title" slot="title">打通企微和药点益</div>
        <div class="secret-content">
          <div class="title">为什么需要填写外部联系人秘钥？</div>
          <div class="txt">
            <p>填写外部联系人秘钥用于打通企业微信和商城的客户管理功能。</p>
          </div>
          <div class="title">如何填写外部联系人秘钥？</div>
          <div class="txt">
            <p>1、用管理员账号，登录"企业微信"管理后台</p>
            <p>2、打开导航--"客户联系"--"客户"页面</p>
            <p>3、如下图，点开"APP"小按钮</p>
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/external-contact1.png" alt="" />
            <p>4、如下图2，点开API，在Secret栏目，复制外部联系人秘钥</p>
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/external-contact2.png" alt="" />
            <p>5、将复制的外部联系人秘钥填写到商盟企业微信配置信息-外部联系人秘钥一栏中</p>
          </div>
        </div>
      </el-drawer>
    </div>
    <div class="show-secret">
      <el-drawer :visible.sync="showRelationSecretKey" direction="rtl" size="664">
        <div class="boder-title" slot="title">打通企微和药点益</div>
        <div class="secret-content">
          <div class="title">为什么需要填写通讯录秘钥？</div>
          <div class="txt">
            <p>填写通讯录秘钥用于打通企业微信和商城的客户管理功能。</p>
          </div>
          <div class="title">如何填写通讯录秘钥？</div>
          <div class="txt">
            <p>1、用管理员账号，登录"企业微信"管理后台</p>
            <p>2、打开导航--"管理工具"--"通讯录同步"页面</p>
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/address-book1.png" alt="" />
            <p>3、复制通讯录秘钥填写到商盟企业微信配置信息-通讯录秘钥一栏中</p>
            <img src="https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/address-book2.png" alt="" />
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'enterprise-weChat',
  data() {
    return {
      isBind: true,
      authorizeLinkUrl: '',
      data: {
        // corpId: 'WX1361QE79679106116',
        contactSecret: '',
        relationSecret: ''
      },
      showContactSecretKey: false,
      showRelationSecretKey: false
    };
  },
  watch: {
    'data.contactSecret'(newValue) {
      this.data.contactSecret = this.formatSecret(newValue);
    },
    'data.relationSecret'(newValue) {
      this.data.relationSecret = this.formatSecret(newValue);
    }
  },
  computed: {
    isLinehight() {
      return this.data.contactSecret && this.data.relationSecret;
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.data = await Fetch.queryAuthorizedSecret();

      // 兼容服务端返回对象中无此字段，导致监控无效
      if (!this.data.contactSecret) {
        this.$set(this.data, 'contactSecret', '');
      }
      if (!this.data.relationSecret) {
        this.$set(this.data, 'relationSecret', '');
      }

      // 获取外链
      this.authorizeLinkUrl = this.data && this.data.authorizeLinkUrl;
    },
    formatSecret(val) {
      return (val && val.replace(/[^a-zA-Z0-9-_]/g, '')) || '';
    },
    onSubmit() {
      delete this.data.authorizeLinkUrl;
      if (!this.isLinehight) return;

      if (this.data.contactSecret.length !== 43) {
        this.$message('外部联系人秘钥长度必须为43位');
        return;
      }
      if (this.data.relationSecret.length !== 43) {
        this.$message('通讯录秘钥长度必须为43位');
        return;
      }

      Fetch.updateAuthorizedSecret(this.data)
        .then(() => {
          this.$message.success('保存成功');
          this.initData(); // 此处重新获取确保前端展示以服务端保存数据为准
        })
        .catch(error => {
          console.log(error);
          // 修改失败还原初始值
          this.initData();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise-weChat {
  width: 100%;
  overflow: hidden;

  .box-wrap {
    width: 100%;
    background: #fff;
    overflow-y: auto;
    height: calc(100vh - 136px);
    border-radius: 4px;
    border: 1px solid #f2f2f2;
    box-shadow: 0px 4px 12px 0px #ededed;
  }

  .box1 {
    .banner-inner {
      width: 100%;
      padding: 54px 30px 48px 63px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-image: url('https://static-volc.91jkys.com/f2e/lemon-scrm-static/image/enterprise-wechat-bg-left.png');
      background-position: top left;
      background-size: contain;
      background-repeat: no-repeat;
      background-color: #1e8dff;

      .wechat-bg-right {
        width: 420px;
      }

      .content {
        z-index: 1000;
        .logo-name {
          color: #fff;
          font-size: 36px;
        }

        .txt2 {
          width: 569px;
          font-size: 14px;
          color: #fff;
          margin-top: 16px;
        }

        .btn1 {
          margin-right: 12px;
        }

        .btns {
          margin-top: 48px;

          .btn {
            width: 208px;
            background: #ffffff;
            box-shadow: 0px 3px 12px 0px rgba(15, 109, 217, 0.65);
            border-radius: 4px;
            padding: 17px 30px;
            height: 48px;
            line-height: 48px;
            box-sizing: border-box;

            .tip {
              padding-left: 8px;
              font-size: 14px;
              color: #8c8c8c;
              font-weight: 400;
            }

            .highLight {
              width: 56px;
              font-weight: 500;
              color: #1e8dff;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .box2 {
    .odds {
      padding: 48px 0 52px;
      font-size: 24px;
      font-weight: 600;
      color: #262626;
      line-height: 24px;
      text-align: center;
    }

    .intros {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;

      width: 100%;

      .intro-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        width: 216px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 18px;
        text-align: left;
        padding-bottom: 30px;

        img {
          width: 108px;
          height: 108px;
          margin-bottom: 20px;
        }

        .title {
          height: 16px;
          font-size: 16px;
          font-weight: 500;
          color: #262626;
          line-height: 16px;
          margin-bottom: 12px;
        }
      }
    }
  }

  .box3 {
    padding: 20px 16px;
    .item {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      margin-bottom: 20px;

      .label {
        width: 98px;
        height: 14px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #707070;
        line-height: 14px;
        margin-right: 24px;
      }

      .txt {
        height: 14px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #262626;
        line-height: 14px;
      }

      .get-secret {
        margin-left: 16px;
        height: 14px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #1e8dff;
        line-height: 14px;
        cursor: pointer;
      }
    }

    .submit {
      margin-left: 119px;

      &.is-disabled {
        background-color: #1e8dff;
        border-color: #1e8dff;
        opacity: 0.5;
      }
    }
  }
}

/deep/.el-drawer__header {
  padding: 24px !important;
  margin-bottom: 0 !important;
}

.boder-title {
  height: 24px;
  font-size: 24px;
  font-weight: 600;
  color: #262626;
  line-height: 24px;
}

.secret-content {
  padding: 0 24px 24px 24px;
  overflow-y: auto;
  height: calc(100vh - 78px);

  .title {
    height: 18px;
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    line-height: 18px;
    margin: 12px 0 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  .txt {
    width: 616px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    line-height: 22px;

    img {
      margin: 12px auto;
      width: 616px;
    }
  }
}
</style>
